import { AddOnIds } from "enums";
import { useAddOnQuery } from "./useAddOnQuery";

export const useHasCreateAccountsAddOn = (accountId: number): boolean => {
  const addOnsQuery = useAddOnQuery(accountId);

  if (!addOnsQuery.isSuccess) {
    return false;
  }
  return addOnsQuery.data?.some((addOn) => addOn.id === AddOnIds.CreateAccounts && addOn.isEnabled) ?? false;
};
